import React, { memo } from 'react';
import { FcFilledFilter } from 'react-icons/fc';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { RiFilterFill, RiFilterOffFill } from 'react-icons/ri';

interface Props {
  Component1?: React.ElementType;
  Component2?: React.ElementType;
  Component3?: React.ElementType;
  Component4?: React.ElementType;
  Component5?: React.ElementType;
  Component6?: React.ElementType;
  Component7?: React.ElementType;
  Component8?: React.ElementType;
  Component9?: React.ElementType;
  Component10?: React.ElementType;
  Component11?: React.ElementType;
  Component12?: React.ElementType;
  Component13?: React.ElementType;
  applyFilter: () => void;
  clearFilter: () => void;
  height?: any;
  id: string;
}
function GlobalSearch({
  applyFilter,
  clearFilter,
  Component1,
  Component2,
  Component3,
  Component4,
  Component5,
  Component6,
  Component7,
  Component8,
  Component9,
  Component10,
  Component11,
  Component12,
  Component13,
  height,
  id,
}: Props) {
  const filterHightUp = () => {
    if (height) {
      $('.filter-page').css({
        height: height,
      });
      $('.hideUp').hide();
      $('.hideDown').show();
    } else {
      $('.filter-page').css({
        height: '260px',
      });
      $('.hideUp').hide();
      $('.hideDown').show();
    }
  };
  const filterHightDown = () => {
    $('.hideUp').show();
    $('.hideDown').hide();
    $('.filter-page').css({
      height: '100px',
    });
  };
  return (
    <div className={id}>
      <div className='filter-page'>
        <div className='filter-child'>
          <div className='filter-icon'>
            <div className='first-icon'>
              <FcFilledFilter size={20} />
              Filter
            </div>
            <div className='second-icon'>
              <div className='hideUp'>
                <IoIosArrowUp onClick={filterHightUp} size={20} />
              </div>
              <div className='hideDown'>
                <IoIosArrowDown onClick={filterHightDown} size={20} />
              </div>
            </div>
          </div>
          <div className='filter-content'>
            <div className='filter-body'>
              <div className='row mb-3'>
                <div className='col-md-12'>
                  <div className='roster-grafik'>
                    {Component1 && <Component1 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component2 && <Component2 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component8 && <Component8 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component3 && <Component3 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component4 && <Component4 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component5 && <Component5 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component7 && <Component7 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component9 && <Component9 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component11 && <Component11 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component10 && <Component10 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component12 && <Component12 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component6 && <Component6 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component13 != undefined &&
                    process.env.REACT_APP_ERP_TYPE == 'MEX' ? (
                      <Component13 />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='filter-footer'>
              <div className='btn-filter w-100' onClick={applyFilter}>
                <span>
                  <RiFilterFill size={15} color='#f7b731' />
                </span>
                <span>Apply filter</span>
              </div>
              <div className='btn-clear-filter  w-100' onClick={clearFilter}>
                <span>
                  <RiFilterOffFill size={15} color='red' />
                </span>
                <span>Clear filter</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(GlobalSearch);
